"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDeviceKindEnum = void 0;
var UserDeviceKindEnum;
(function (UserDeviceKindEnum) {
    UserDeviceKindEnum["WEBAPP"] = "WEBAPP";
    UserDeviceKindEnum["MOBILE"] = "MOBILE";
})(UserDeviceKindEnum || (exports.UserDeviceKindEnum = UserDeviceKindEnum = {}));
